
import * as d3 from "d3";


const CON_StateFipsCodeLength = 2;
const CON_CountyFipsCodeLength = 5;


// data files
const CON_DF_DevCdnUrl = "https://d2zdr3mvpkc8hj.cloudfront.net";
const CON_DF_ProdCdnUrl = "https://d13m0t4ghiw3a0.cloudfront.net";
//console.log(window.location.host);
let cdnUrl
  = ( window.location.host.toLowerCase().startsWith("vaccinations.iem-modeling.com")
    || window.location.host.toLowerCase().startsWith("icoe.iem-modeling.com"))
  ? CON_DF_ProdCdnUrl
  : CON_DF_DevCdnUrl;
let CON_DF_Fips = cdnUrl + "/vacc-fips.csv";
let CON_DF_JurisdictionTypes = cdnUrl + "/vacc-jurisdiction-types.csv";
let CON_DF_ModelDataRoot = cdnUrl + "/vacc-model-data-";
let CON_DF_Multipliers = cdnUrl + "/vacc-multipliers.csv";
let CON_DF_VaxRates = cdnUrl + "/vacc-rates.csv";
let CON_DF_RunConfigs = cdnUrl + "/vacc-run-configs.csv";
let CON_DF_Timestamp = cdnUrl + "/vacc-timestamp.txt";


// =====
// =====
// TYPES
// =====
// =====


type dateString_t = string; // for documentation purposes


interface fips_t {
  readonly fips: number
  , readonly fipsCode: string
  , readonly parentFips: number
  , readonly parentFipsCode: string
  , readonly isTerritory: boolean
  , readonly jurisdictionTypeName: string
  , readonly population: number
  , readonly abbrev: string
  , readonly name: string
  , readonly fullName: string
}

interface jurisdictionType_t {
  readonly id: number
  , readonly code: string
  , readonly lcCode: string
  , readonly name: string
  , readonly desc: string
  , readonly orderBy: number
}

interface multiplier_t {
  readonly id: number
  , readonly code: string
  , readonly lcCode: string
  , readonly name: string
  , readonly desc: string
  , readonly orderBy: number
}

interface vaxRate_t {
  readonly id: number
  , readonly code: string
  , readonly lcCode: string
  , readonly name: string
  , readonly desc: string
  , readonly orderBy: number
}

interface runConfig_t {
  readonly id: number
  , readonly code: string
  , readonly lcCode: string
  , readonly name: string
  , readonly desc: string
  , readonly orderBy: number
  , readonly targetRateId: number
  , readonly multiplierId: number
}

interface modelData_t {
  readonly fipsCode: string
  , readonly runConfigId: number
  , readonly runConfigCode: string
  , readonly validDate: dateString_t
  , readonly projectedCasesLow: number
  , readonly projectedCasesBest: number
  , readonly projectedCasesHigh: number
  , readonly projectedDeathsLow: number
  , readonly projectedDeathsBest: number
  , readonly projectedDeathsHigh: number
}


// =========
// =========
// FUNCTIONS
// =========
// =========


let _dataLoadingPromise:Promise<boolean> = null;


// data
let _ds_fips:Map<string,fips_t> = null;
let _ds_jurisdictionTypes:Map<string,jurisdictionType_t> = null;
let _ds_multipliers:Map<string,multiplier_t> = null;
let _ds_vaxRates:Map<string,vaxRate_t> = null;
let _ds_runConfigs:Map<string,runConfig_t> = null;
let _ds_modelData:Map<string,Map<string,modelData_t>> = null;
let _timestamp:dateString_t = null;



// promises
let _fipsPromise:Promise<any> = null;
let _jurisdictionTypesPromise:Promise<any> = null;
let _modelDataPromises:Map<string,Promise<any>> = null;
let _multipliersPromise:Promise<any> = null;
let _vaxRatesPromise:Promise<any> = null;
let _runConfigsPromise:Promise<any> = null;
let _timestampPromise:Promise<any> = null;


function getLastValidDate() {
  return "2021-07-19";
}


function getFips() {
  return _ds_fips;
}


function getJurisdictionTypes() {
}


function getModelDataPromise(i_RunConfigCode:string) {
  // console.log("dataLoading.ts :: getModelDataPromises :: i_RunConfigCode: " + i_RunConfigCode);
  // console.log("dataLoading.ts :: getModelDataPromises :: promise: " + _modelDataPromises.get(i_RunConfigCode));
  return _modelDataPromises.get(i_RunConfigCode);
}


function getMultipliers() {
}


function getVaxRates() {
}


function getRunConfigs() {
  return _ds_runConfigs;
}


function getTimestamp() {
  return _timestamp;
}


function loadData() {
  if (_dataLoadingPromise === null) _dataLoadingPromise = loadData_Internal();
  return _dataLoadingPromise;
}


function loadData_Internal() {
  // console.log("dataLoading :: loadData_Internal");


  // ==============
  // get data files

  function loadFips() {
    return d3.csv(CON_DF_Fips
      , d => {
        // fipsCode
        let fipsCode:string = d.fips.toString();
        if (fipsCode.length <= CON_StateFipsCodeLength) {
           fipsCode = fipsCode.padStart(CON_StateFipsCodeLength,'0');
        } else if (fipsCode.length < CON_CountyFipsCodeLength) {
           fipsCode = fipsCode.padStart(CON_CountyFipsCodeLength,'0');
        }

        // parentFipsCode
        let parentFipsCode:string = d.parent_fips.toString();
        if (parentFipsCode.length <= CON_StateFipsCodeLength) {
           parentFipsCode = parentFipsCode.padStart(CON_StateFipsCodeLength,'0');
        } else if (parentFipsCode.length < CON_CountyFipsCodeLength) {
           parentFipsCode = parentFipsCode.padStart(CON_CountyFipsCodeLength,'0');
        }

        let o:fips_t = {
          fips: +d.fips
          , fipsCode: fipsCode
          , parentFips: +d.parent_fips
          , parentFipsCode: parentFipsCode
          , isTerritory: !!d.is_territory
          , jurisdictionTypeName: d.jurisdiction_type_name
          , population: +d.population
          , abbrev: d.abbrev
          , name: d.name
          , fullName: d.full_name
        };

        _ds_fips.set(fipsCode, o);
        return null;
      })
      .catch(err => {
        // console.log("DataLoading :: No FIPS");
        // console.log(err);

        _ds_fips = null;
        return null;
      }); // in case fails after partial completion
  }

  // jurisdiction_type_id,jurisdiction_type_code,lc_jurisdiction_type_code,jurisdiction_type_name,jurisdiction_type_desc,orderby
  function loadJurisdictionTypes() {
    return d3.csv(CON_DF_JurisdictionTypes
      , d => {
        let o:jurisdictionType_t = {
          id: +d.jurisdiction_type_id
          , code: d.jurisdiction_type_code
          , lcCode: d.lc_jurisdiction_type_code
          , name: d.jurisdiction_type_name
          , desc: d.jurisdiction_type_desc
          , orderBy: +d.orderby
        };

        _ds_jurisdictionTypes.set(d.jurisdiction_type_code,o);
        return null;
      })
      .catch(err => {
        // console.log("DataLoading :: No FIPS");
        // console.log(err);

        _ds_jurisdictionTypes = null;
        return null;
      }); // in case fails after partial completion
  }

  // id,code,lc_code,name,desc,orderby
  function loadMultipliers() {
    return d3.csv(CON_DF_Multipliers
      , d => {
        let o:multiplier_t = {
          id: +d.id
          , code: d.code
          , lcCode: d.lc_code
          , name: d.name
          , desc: d.desc
          , orderBy: +d.orderby
        };

        _ds_multipliers.set(d.code,o);
        return null;
      })
      .catch(err => {
        // console.log("DataLoading :: No FIPS");
        // console.log(err);

        _ds_multipliers = null;
        return null;
      }); // in case fails after partial completion
  }

  // id,code,lc_code,name,desc,orderby
  function loadVaxRates() {
    return d3.csv(CON_DF_VaxRates
      , d => {
        let o:vaxRate_t = {
          id: +d.id
          , code: d.code
          , lcCode: d.lc_code
          , name: d.name
          , desc: d.desc
          , orderBy: +d.orderby
        };

        _ds_vaxRates.set(d.code,o);
        return null;
      })
      .catch(err => {
        // console.log("DataLoading :: No FIPS");
        // console.log(err);

        _ds_vaxRates = null;
        return null;
      }); // in case fails after partial completion
  }


  function loadTimestamp() {
    return d3.text(CON_DF_Timestamp);
  }

  // id,code,lc_code,name,desc,orderby,target_rate_id,multiplier_id 
  function loadRunConfigs() {
    return d3.csv(CON_DF_RunConfigs
      , d => {
        let o:runConfig_t = {
          id: +d.id
          , code: d.code
          , lcCode: d.lc_code
          , name: d.name
          , desc: d.desc
          , orderBy: +d.orderby
          , targetRateId: +d.target_rate_id
          , multiplierId: +d.multiplier_id 
        };

        _ds_runConfigs.set(d.code, o);
        return null;
      })
      .catch(err => {
        // console.log("DataLoading :: No Run Configs");
        // console.log(err);

        _ds_runConfigs = null;
        return null;
      }); // in case fails after partial completion
  }


  // ==================
  // create Map objects

  _ds_fips = new Map();
  _ds_jurisdictionTypes = new Map();
  _ds_modelData = new Map();
  _ds_multipliers = new Map();
  _ds_vaxRates = new Map();
  _ds_runConfigs = new Map();


  // ============
  // set promises

  _fipsPromise = loadFips();
  _jurisdictionTypesPromise = loadJurisdictionTypes();
  _multipliersPromise = loadMultipliers();
  _vaxRatesPromise = loadVaxRates();
  _timestampPromise = loadTimestamp();
  _runConfigsPromise = loadRunConfigs();


  // =========================
  // check individual promises

  _fipsPromise.then(() => {
      // console.log("DataLoading :: FIPS count: " + _ds_fips.size);
      // console.log(_ds_fips);
    });
  _jurisdictionTypesPromise.then(() => {
      // console.log("DataLoading :: Jurisdiction Type count: " + _ds_jurisdictionTypes.size);
      // console.log(_ds_jurisdictionTypes);
    });
  _multipliersPromise.then(() => {
      // console.log("DataLoading :: Multipliers count: " + _ds_multipliers.size);
      // console.log(_ds_multipliers);
    });
  _vaxRatesPromise.then(() => {
      // console.log("DataLoading :: Vax Rate count: " + _ds_vaxRates.size);
      // console.log(_ds_vaxRates);
    });


  // =============================================
  // after getting run configs --> load model data

  let returnPromise:Promise<any> = null;

  const modelDataPromisesFilled = _runConfigsPromise.then(() => {
      if (_ds_runConfigs === null)  throw new Error("DataLoading :: No Run Configs");

      // logging
      // console.log("DataLoading :: Run Configs count: " + _ds_runConfigs.size);
      // console.log(_ds_runConfigs);


      // load data sets
      _modelDataPromises = new Map();
      _ds_runConfigs.forEach((rc, code) => {
          let m:Map<string,modelData_t> = new Map();
          _ds_modelData.set(code,m);

          let filename:string = CON_DF_ModelDataRoot + rc.id + ".csv";
          // fips,run_config,valid_date,projected_cases_low,projected_cases_best,projected_cases_high,projected_deaths_low,projected_deaths_best,projected_deaths_high
          let p:Promise<any> = d3.csv(filename
            , d => {
              // fipsCode
              let fipsCode:string = d.fips.toString();
              if (fipsCode.length <= CON_StateFipsCodeLength) {
                 fipsCode = fipsCode.padStart(CON_StateFipsCodeLength,'0');
              } else if (fipsCode.length < CON_CountyFipsCodeLength) {
                 fipsCode = fipsCode.padStart(CON_CountyFipsCodeLength,'0');
              }

              let o:modelData_t = {
                fipsCode: fipsCode
                , runConfigId: +d.run_config
                , runConfigCode: d.code
                , validDate: d.valid_date
                , projectedCasesLow: +d.projected_cases_low
                , projectedCasesBest: +d.projected_cases_best
                , projectedCasesHigh: +d.projected_cases_high
                , projectedDeathsLow: +d.projected_deaths_low
                , projectedDeathsBest: +d.projected_deaths_best
                , projectedDeathsHigh: +d.projected_deaths_high
              }

              m.set(fipsCode + ":" + o.validDate, o)
              return null;
          });
          _modelDataPromises.set(code,p.then(()=>_ds_modelData.get(code)));
      });
    });


  // =================================================================================
  // create and return promise that resolves when all data except for models is loaded
  return new Promise<boolean>((resolve, reject) => {
    modelDataPromisesFilled.then(() => {
      const dsCount = _modelDataPromises.size;
      // console.log("dsCount: " + dsCount);
      const dsPromiseArray = new Array<Promise<any>>(dsCount);
      let i:number = 0;
      _modelDataPromises.forEach(p => {
        dsPromiseArray[i++] = p;
      });

      const p = Promise.all(dsPromiseArray);
      Promise.all([_timestampPromise, _fipsPromise, _jurisdictionTypesPromise, _multipliersPromise, _vaxRatesPromise, _runConfigsPromise, p]).then(values => {
        // timestamp is handled here because it is not from a csv file (csv files have row processing)
        _timestamp = values[0];
  
        resolve(true);
      })
      .catch(err => {
        // console.log("DataLoading :: Loading failed");
        // console.log(err);
        reject(false);
      });
    });
  });
}
      


export {
  loadData
  , getFips
  , getModelDataPromise
  , getRunConfigs
  , getTimestamp
  , getLastValidDate
  , fips_t
  , modelData_t
};

